<router-outlet></router-outlet>
<wai-connection-status></wai-connection-status>
